import ab from '../ruleset/ab';
import { duration } from './duration';

// US PACIFIC TIMEZONE ------------------------------------

export const PST_UTC_OFFSET = duration({ hours: -8 });
export const getPSTOffset = (date: Date): number => {
  const now = date.getTime();
  const minsPSTOffset = Math.round(
    (getPSTDate(now).getTime() - now) / 1000 / 60,
  );
  return duration({ minutes: minsPSTOffset + date.getTimezoneOffset() }); // PST offset + date's own offset
};
export function getPSTDate(now: number): Date {
  const date = new Date(now);
  const pstDateStr = date.toLocaleString('en-US', {
    timeZone: 'America/Los_Angeles',
  });
  return new Date(pstDateStr); // new date is PST "shifted"
}
export const formatPSTTime = (now: number): string =>
  new Date(now).toLocaleString('en-US', {
    timeZone: 'America/Los_Angeles',
    dateStyle: 'medium',
    timeStyle: 'long',
  });

// JAPAN TIMEZONE -----------------------------------------

// used by tests
export const JST_UTC_OFFSET = duration({ hours: 9 });
export const getJSTOffset = (date: Date): number =>
  JST_UTC_OFFSET + duration({ minutes: date.getTimezoneOffset() });

export function getJSTDate(now: number): Date {
  const date = new Date(now);
  return new Date(date.getTime() + getJSTOffset(date));
}

export const formatJSTTime = (now: number): string =>
  new Date(now).toLocaleString('en-US', {
    timeZone: 'Asia/Tokyo',
    dateStyle: 'medium',
    timeStyle: 'long',
  });

// REGIONAL TIMEZONE --------------------------------------

/** Default region is US Pacific, in case we can't get the user's timezone */
export const DEFAULT_TIMEZONE = 'America/Los_Angeles';

/** Get user's timezone from state */
export function getLocalTimezone(state: Record<string, any>): string {
  // State type is set as generic object for practical reasons, check here if it is actually an object
  if (typeof state !== 'object') {
    throw new Error('Invalid state object provided');
  }

  return state?.timeZone || DEFAULT_TIMEZONE;
}

/** Get date's own offset with provided timezone */
export const getLocalOffset = (date: Date, timeZone: string): number => {
  const now = date.getTime();
  const minsOffset = Math.round(
    (getLocalDate(now, timeZone).getTime() - now) / 1000 / 60,
  );
  return duration({ minutes: minsOffset + date.getTimezoneOffset() });
};

/** Get date based on given UTC time and user's timezone */
export function getLocalDate(now: number, timeZone: string): Date {
  const date = new Date(now);
  const dateStr = date.toLocaleString('en-US', { timeZone });
  return new Date(dateStr);
}

/** Format date based on given UTC time and user's timezone, in en-US format */
export const formatLocalTime = (now: number, timeZone: string): string =>
  new Date(now).toLocaleString('en-US', {
    timeZone,
    dateStyle: 'medium',
    timeStyle: 'long',
  });
